/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



// Met à jour l'EAN affiché dans "Détails du produit" quand la couleur change
// (product-tabs.liquid ne rend l'EAN qu'une fois, pour la variante par défaut)
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || typeof theme === 'undefined' || !theme.PUB_SUB_EVENTS) return;

  subscribe(theme.PUB_SUB_EVENTS.variantChange, function (payload) {
    var variant = payload && payload.data && payload.data.variant;
    if (!variant) return;

    document.querySelectorAll('[data-ean-value]').forEach(function (el) {
      el.textContent = variant.barcode || '';
      var wrapper = el.closest('[data-product-ean]');
      if (wrapper) wrapper.style.display = variant.barcode ? '' : 'none';
    });

    document.querySelectorAll('[data-sku-value]').forEach(function (el) {
      el.textContent = variant.sku || '';
      var wrapper = el.closest('[data-product-sku]');
      if (wrapper) wrapper.style.display = variant.sku ? '' : 'none';
    });
  });
});
